import { FC, useCallback } from 'react';
import { DeviceErrorMap } from 'models';
import Accordion from 'components/UI/Accordion';
import AccordionItem from 'components/UI/Accordion/AccordionItem';
import SortableTable, { HeaderCell } from 'components/UI/Table/SortableTable';
import { SortOrder } from 'utils/array';
import { format } from 'date-fns';

type Props = {
  deviceErrors: DeviceErrorMap[] | null;
};
const headerCells: HeaderCell[] = [
  {
    title: 'connectivity.device_errors_timestamp',
    sortable: true,
  },
  {
    title: 'connectivity.device_errors_message',
    sortable: true,
  },
];

const DeviceErrorTree: FC<Props> = ({ deviceErrors }) => {
  const getAccordionItems = useCallback(
    (deviceErrors: DeviceErrorMap[] | null) => {
      if (!deviceErrors) {
        return null;
      }

      return deviceErrors.map((error) => {
        // Table rows
        let rowIndex = 0;
        const bodyRows = error.deviceErrors.map((deviceError) => {
          const { code, timestamp, data } = deviceError;
          const resourceText =
            data?.resource && data?.resource !== 'undefined'
              ? data.resource
              : '';
          return {
            time: format(new Date(timestamp), 'yyyy-MM-dd HH:mm:ss'),
            message: data
              ? `${data.action} ${data.object} ${resourceText}`
              : '–',
            link: `${code}-${rowIndex++}`,
          };
        });
        return (
          <AccordionItem key={error.code} title={error.code}>
            <SortableTable
              headerCells={headerCells}
              bodyRows={bodyRows}
              sortOrder={SortOrder.Asc}
              sortIndex={0}
            />
          </AccordionItem>
        );
      });
    },
    []
  );

  return (
    <div className="deviceErrors">
      <Accordion>{getAccordionItems(deviceErrors)}</Accordion>
    </div>
  );
};

export default DeviceErrorTree;
